// TODO: remove in future
// export default {
//   getlastViewed: (state, getters) => {
//     return state.recent_cases
//   }
// }
